import React, { SetStateAction } from 'react';

import Typography from '@components/typography';

import '@styles/customise/availableoption.scss';

import { AvailableOption as AvailableOptionData } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/availableoption';

export interface AvailableOptionProps {
  variant: 'trim' | 'hood' | 'optional' | 'colour';
  option: AvailableOptionData;
  setSelectedOption: React.Dispatch<SetStateAction<number>>;
}

const AvailableOption: React.FC<AvailableOptionProps> = ({
  variant,
  option,
  setSelectedOption,
}) => {
  const { id, title, price, monthlyRentalCost } = option;

  const onSelectedOptionClicked = (optionId: number) => {
    setSelectedOption(optionId);
  };

  return (
    <div data-testid="available-option" className="available-option">
      <label
        className="available-option__label"
        htmlFor={`available-option-check-${id}`}
      >
        <div className="available-option__value">
          <input
            name={variant}
            className="option"
            value={id}
            type="radio"
            aria-label="Choose"
            checked={option.checked}
            onChange={() => {}}
            onClick={() => onSelectedOptionClicked(option.id)}
            data-testid="available-option-check"
            id={`available-option-check-${id}`}
          />
        </div>

        <div className="available-option__title">
          <Typography variant="caption" size="rg">
            {title}
          </Typography>
        </div>
        <div className="available-option__price">
          <Typography variant="caption" size="rg">
            {`${monthlyRentalCost} p/m`}
          </Typography>
          <Typography variant="caption" size="rg">
            {price}
          </Typography>
        </div>
      </label>
    </div>
  );
};

export default AvailableOption;
